import NavMenu from "@/components/NavMenu";
import Clock from "@/components/shared/Clock";
import CopyRightFooter from "@/components/shared/CopyRightFooter";
import {
  FILTER_MY_PATIENTS,
  GRID_VIEW,
  SORT_BY_ROOM,
  UNIT_ALL
} from "@/components/shared/util";
import { navigationNamespace } from "@/store/modules/navigation";
import { patientNamespace } from "@/store/modules/patient";
import { ViewConfig } from "@/store/modules/patient/config";
import { userNamespace } from "@/store/modules/user";
import _ from "lodash";
import { Component, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { Colors } from "../components/shared/util";

@Component({
  components: { CopyRightFooter, Clock, NavMenu }
})
export default class ProductSelect extends Vue {
  @Action("setArea", userNamespace)
  setArea!: Function;

  @Getter("area", userNamespace)
  area!: string;

  @Getter("areas", userNamespace)
  areas!: Array<string>;

  @Getter("darkMode", navigationNamespace)
  dark!: boolean;

  @Getter("censusPreferences", navigationNamespace)
  censusPreferences!: any;

  @Getter("user", userNamespace)
  user!: any;

  @Getter("allVars", patientNamespace)
  allVars!: Record<string, any>;

  @Getter("views", patientNamespace)
  views!: ViewConfig[];

  @Action("setShownLoginMs", userNamespace)
  setShownLoginMs!: Function;

  @Getter("hasShownLoginMs", userNamespace)
  hasShownLoginMs!: boolean;

  get showLoginMs() {
    const result =
      this.user.isAdmin === true &&
      !this.hasShownLoginMs &&
      this.user.loginMs > 100 &&
      !this.dismissed;
    if (!this.hasShownLoginMs) {
      this.setShownLoginMs(true);
    }
    return result;
  }

  dismissed = false;

  async navigateToCensus() {
    const params: any = { area: this.area, unit: UNIT_ALL };
    const savedPrefs = this.censusPreferences[this.area];
    if (savedPrefs) {
      Object.assign(params, savedPrefs);
    }

    const { defaultSort, defaultFilter } = _.get(
      this.allVars[this.area],
      "uiConfig.elements",
      { defaultSort: SORT_BY_ROOM, defaultFilter: FILTER_MY_PATIENTS }
    );

    // null is set when all filters are removed
    if (!params.filters && params.filters !== null) {
      params.filters = defaultFilter;
    }

    if (!params.sort) {
      params.sort = defaultSort;
    }

    if (!params.view) {
      params.view = _.get(this.views, "[0].routerString", GRID_VIEW);
    }

    this.$router.push({
      name: "census",
      params
    });
  }

  selectArea(area: string) {
    this.setArea(area);
    this.navigateToCensus();
  }

  async mounted() {
    this.setArea("");
    if (this.areas && this.areas.length === 1) {
      this.selectArea(this.areas[0]);
    }
  }

  get loginTimeDisplay() {
    if (!this.user.loginMs) {
      return "";
    }
    return (
      "Login took <b>" +
      (this.user.loginMs > 1000
        ? (this.user.loginMs / 1000.0).toString() + "</b> seconds"
        : this.user.loginMs.toString() + "</b> milliseconds")
    );
  }

  back() {
    this.$router.go(-1);
  }

  get userFullName() {
    return this.user.name;
  }

  get isAdmin() {
    return this.user.isAdmin === true;
  }

  get StatusGreen() {
    return Colors.TestGreen;
  }

  get isMobileThin() {
    return (
      this.$vuetify.breakpoint.smAndDown && this.$vuetify.breakpoint.width < 600
    );
  }
  async status() {
    this.$router.push({ path: "/status" });
  }
}
